/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_ClassifiersInputs */

const en_advantages_sample_classifiers = /** @type {(inputs: Advantages_Sample_ClassifiersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`instead we simply use independent logistic classifiers. Dur- ing training we use binary cross-entropy loss for the class predictions.`)
};

const es_advantages_sample_classifiers = /** @type {(inputs: Advantages_Sample_ClassifiersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en su lugar utilizamos clasificadores logísticos independientes. Durante el entrenamiento usamos la pérdida de entropía cruzada binaria para las predicciones de clase.`)
};

/**
* | output |
* | --- |
* | "instead we simply use independent logistic classifiers. Dur- ing training we use binary cross-entropy loss for the class predictions." |
*
* @param {Advantages_Sample_ClassifiersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_classifiers = /** @type {((inputs?: Advantages_Sample_ClassifiersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_ClassifiersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_classifiers(inputs)
	return en_advantages_sample_classifiers(inputs)
});